import axios from 'axios'
import { getToken } from 'providers/AuthProvider'
import humps from 'humps'

const instance = axios.create({
  baseURL: '/',
  headers: { Accept: 'application/json' },
})

instance.defaults.withCredentials = true

instance.interceptors.request.use(async (config) => {
  const newConfig = { ...config, baseURL: '/api' }
  if (!newConfig?.headers) {
    throw new Error("Expected 'config' and 'config.headers' to be defined")
  }
  return newConfig
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addAccessConfig = async (getAccessTokenSilently: any) => {
  instance.interceptors.request.use(
    async (config) => {
      const newConfig = { ...config }
      if (!newConfig?.headers) {
        throw new Error("Expected 'config' and 'config.headers' to be defined")
      }

      const token = await getToken(getAccessTokenSilently)
      if (token) {
        newConfig.headers.authorization = token
        return newConfig
      }

      return newConfig
    },
    (error) => Promise.reject(error)
  )
}

instance.interceptors.response.use(
  (response) => {
    const formatResponse = humps.camelizeKeys(response)
    return formatResponse
  },
  (error) => Promise.reject(error)
)

export default instance
